import Highcharts from 'highcharts';

// Registers the custom `column2` series type: a plain column, aliased so a second column series can
// be drawn side-by-side / overlaid with the built-in `column` on the same axis. Import this module
// for its side effect from every chart that renders a `column2` series. Highcharts overwrites
// silently on re-registration, so importing it from multiple places is safe.
Highcharts.seriesType('column2', 'column', {});
